module.exports = __webpack_public_path__ + "static/media/ambassadors_office.cd4b31cc.png";